export class Otp {
    otp_id: string;
    ekpay_id: string;
    otp: string;
    otp_status: string;
    mobile: string;
    generate_time: string;
    expiry_time: string;
    module: string;
    otp_type: string;
    email_id: string;
    mode: string;
}

export class OTPResponse {
    status: string;
    reason: string;
    otp: Otp;
    ekpay_id: string;
    message: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/registeration/gen-otp-response.ts